import React from 'react'
import { AutoComplete, Button, Input, DatePicker, Badge, Form, Popconfirm } from "antd";
import { getPostContributionApi, deleteContributionApi } from "../../services/apiService";
import { showApiError } from "../utilities";
import { record_operation } from "../enums";
import "moment/locale/en-nz";
import moment from "moment";
import ContributionLines from "./ContributionLines";

export default function fnContributionDetails(props) {

  const memberList =  [
      {
        value: props.contribution.offeringNo,
        text: props.contribution.displayName
      }
    ];
  const selectedMember = { name: props.contribution.displayName, offeringNo: props.contribution.offeringNo }
  const contribution = props.contribution 

  const allowEditMember = props.contribution.contributorId < 1
  const dateFormat = "DD-MM-YYYY";
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 4 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 }
    }
  };

  function handleMemberSearch(searchValue) {

  }

  function handleMemberOnChange(changedValue) {

  }

  function handleMemberOnSelect(selectedValue) {

  }

  function handleMemberOnBlur(e) {

  }

  function handleOnFocus(e) {

  }

  function handleSave() {
    //console.log("saving contrbution...");
    let savingContribution = getSavingContribution();
    let validatedMessage = validateSavingContribution(savingContribution);
    if (validatedMessage === "") {
      doSave(savingContribution);
    } else {
      showApiError(validatedMessage);
    }

  }

  function handleDelete() {
    let dstring = moment(contribution.contributionDate).format("YYYYMMDD")
    //let dstring = this.contribution.contributionDate 
    deleteContributionApi(contribution.contributionId, dstring)
      .then(json => {
        if (typeof json === "string") {
          throw new Error(json);
        } else {
          props.postSave(
            json,
            record_operation.DELETE
          );
        }
      })
      .catch(error => {
        showApiError(error);
      });

  }

  function doSave(updatedContribution) {
    //do something here,
    let operation;
    if (updatedContribution.contributionId > 0) {
      operation = record_operation.UPDATE;
    } else {
      operation = record_operation.ADD;
    }
    getPostContributionApi(updatedContribution)
      .then(json => {
        if (typeof json === "string") {
          throw new Error(json);
        } else {
          props.postSave(
            json,
            operation
          );
        }
      })
      .catch(error => {
        showApiError(error);
      });
  };

  function validateSavingContribution(updatedContribution) {
    let result = "";
    if (parseInt(updatedContribution.contributorId) < 0) {
      result = "Member cannot be blank.";
    }
    if (updatedContribution.contributionLines.length === 0) {
      result = "Nothing to save.";
    }
    return result;
  }

  function getSavingContribution() {
    //remove empty lines
    let lines = contribution.contributionLines
      .filter(line => {
        return (
          line.contributionLineId > 0 ||
          (line.contributionLineId < 0 && parseFloat(line.amount) > 0 && (line.fund && line.fund.trim().length > 0))
        );
      })
      .map(ln => {
        let updatedline = { ...ln }; // clone the line instead of reference it
        if (updatedline.contributionLineId < 0) {
          updatedline.contributionLineId = 0;
        }
        return updatedline;
      });

    let savingContribution = contribution
    savingContribution.contributionLines = lines

     // clone to object
    if (savingContribution.contributionId < 0) {
      savingContribution.contributionId = 0;
    }
    return savingContribution;
  };

  function handleRowUpdate(rowData) {
    //console.log("handledRowUpdate rowdata: ");
    let contributionLines = contribution.contributionLines.slice();
    let found = false;
    for (let index = 0; index < contributionLines.length; index++) {
      let line = contributionLines[index];
      if (line.contributionLineId === rowData.contributionLineId) {
        line = { ...line, ...rowData };
        contributionLines[index] = line;
        found = true;
        break;
      }
    }
    if (!found) {
      contributionLines.push(rowData);
    }

    //this.contribution.contributionLines = contributionLines;

    let newRecord = contribution
    newRecord.contributionLines = contributionLines
    //console.log("row update ")
    //console.log(contribution);
    props.setContribution(newRecord)
    //console.log("contributionDetails.handlerowUpdate")
    return contributionLines.reduce((total, p) => total + (p.amount || 0), 0)

  }

  function onDateChange(e) {

    let contributionDate = moment(e).format("YYYY-MM-DD");
    let newValue = {
      ...contribution, contributionDate
    }
    //console.log( newValue)
    props.setContribution(newValue)
  };

  //console.log("fuContributionDetails render")
  //console.log( contribution.contributionLines)
  return (
    <Form autoComplete="nope" className="side-form">
      <div className="panel" style={{ padding: 10 }}>
        <h4>Contribution</h4>
      </div>
      <Form.Item {...formItemLayout} label="Date">
        <DatePicker
          allowClear={false}
          autoFocus={true}
          format={dateFormat}
          defaultValue={moment(props.contributionDate)}
          onChange={onDateChange}
        />
      </Form.Item>
      <Form.Item {...formItemLayout} label="Member">
        <AutoComplete
          style={{ width: "85%" }}
          backfill={false}
          dataSource={memberList}
          onSearch={handleMemberSearch}
          onChange={handleMemberOnChange}
          onSelect={handleMemberOnSelect}
          onBlur={handleMemberOnBlur}
          defaultValue={selectedMember.name}
          value={selectedMember.name}
          optionLabelProp="value"
          disabled={!allowEditMember}
        >
          <Input onFocus={handleOnFocus} />
        </AutoComplete>{" "}
        <Badge
          count={selectedMember.offeringNo}
          showZero
          style={{
            backgroundColor: "#fff",
            color: "#999",
            boxShadow: "0 0 0 1px #d9d9d9 inset"
          }}
          overflowCount={10000}
        />
      </Form.Item>
      <ContributionLines
        funds={props.funds}
        lines={contribution.contributionLines}
        contributionId={contribution.contributionId}
        rowUpdate={handleRowUpdate}
      /> 
      <Form.Item wrapperCol={{ span: 24, offset: 1 }}>
        <Button icon="save" type="primary" onClick={handleSave} style={{ margin: '0px 5px 0px 0px' }}>
          Save
          </Button>
        <Popconfirm
          title="Are you sure delete this contributor?"
          onConfirm={handleDelete}
          okText="Yes"
          cancelText="No">
          <Button icon="delete" disabled={allowEditMember} type="danger">Delete</Button>{" "}
        </Popconfirm>
      </Form.Item>
    </Form>
    )
}
